var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popper',{attrs:{"trigger":_vm.triggerType,"options":{
    placement: _vm.positionType,
    modifiers: { offset: { offset: '0,5px' } },
  }}},[_c('div',{staticClass:"popper p-2 rounded-0 shadow-sm border"},[_vm._v(" "+_vm._s(_vm.content)+" ")]),_c('div',{attrs:{"slot":"reference"},slot:"reference"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }